import cx from 'classnames';
import React from 'react';

import style from './ItineraryTagList.module.css';

type Props = {
    tags: Array<string>;
};

export function ItineraryTagList({ tags }: Props) {
    return (
        // eslint-disable-next-line local-rules/no-global-typography-classes -- ADR-0017: à migrer vers <Typography>
        <ul data-testid="ItineraryTagList" className={cx('font-xs-regular', style.list)}>
            {tags.map((tag, index) => {
                return (
                    // eslint-disable-next-line local-rules/no-global-typography-classes -- ADR-0017: à migrer vers <Typography>
                    <li key={index} className={cx('font-xs-regular', style.item)}>
                        {tag}
                    </li>
                );
            })}
        </ul>
    );
}
